
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChevronTrippleRight as ObiChevronTrippleRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chevron-tripple-right.js';
 
 
 

 
 export const ObiChevronTrippleRight = createComponent({
   react: React,
   tagName: 'obi-chevron-tripple-right',
   elementClass: ObiChevronTrippleRightElement,
   events: {
     
   }
  });
 
 